import type { AccessDecision } from '../../../core/components/PermissionGuard/PermissionGuard';

type ResolveIntegratedManagementAccessParams = {
  flagEnabled: boolean;
  isChecking: boolean;
  hasPermission: boolean;
};

export const resolveIntegratedManagementAccess = ({
  flagEnabled,
  isChecking,
  hasPermission,
}: ResolveIntegratedManagementAccessParams): AccessDecision => {
  if (!flagEnabled) return 'deny';
  if (isChecking) return 'loading';
  if (!hasPermission) return 'deny';
  return 'allow';
};
